export const numberValidation = (phone) => (phone ? /^\d+$/.test(phone) : '');

export const isNumber = (value) => /^\d+$/.test(value);
